export const expand = () => {
    window['HubSpotConversations']?.widget.open();
}
